import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
const controlledActions = {
    create: [-1],
    fetch: [0],
    update: [-1],
    delete: [-1],
    downloadList: [-1],
    uploadList: [-1]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'id', field: 'id', label: 'ID' },
        { name: 'user_id', field: 'user_id', label: 'User', references: 'users.users' },
        { name: 'app_id', field: 'app_id', label: 'App', references: 'apps.apps' },
        { name: 'menu_id', field: 'menu_id', label: 'Menu ID' },
        { name: 'menu_name', field: 'menu_id', label: 'Menu name', references: 'users.users' },
        { name: 'menu_description', field: 'menu_id', label: 'Menu description', complexlyReferences: { table: rootState['users.users'].list, reference_value_field: 'id', type: 'labelField', reference_label_field: 'description' } }
    ];
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    apiVersion: 0,
    remoteEntityName: 'meta.ui_menus_user_defaults',
    controlledActions
});
export default localEntity;
